module.exports = __webpack_public_path__ + "static/eastwood-order-completed-a6fb29e6eeb98cb781d25dc958c0c942.svg";